import React, { useEffect, useState } from "react";
import { copyIcon } from "../../../assets/img/icons/copyIcon";
import { formatAddress } from "../../../utils/utils";
import { TableRow, TableWrapper } from "./SinfleNftTable.styled";

export const SingleNftTable = () => {
  const [copyAddress, setCopyAddress] = useState(false);
  const [copyContract, setCopyContract] = useState(false);

  useEffect(() => {
    if (copyAddress === true) {
      setCopyContract(false);
      setTimeout(() => {
        setCopyAddress(false);
      }, 3000);
    }
  }, [copyAddress]);

  useEffect(() => {
    if (copyContract === true) {
      setCopyAddress(false);
      setTimeout(() => {
        setCopyContract(false);
      }, 3000);
    }
  }, [copyContract]);

  return (
    <TableWrapper>
      <h5>Details:</h5>
      <TableRow>
        <div>Contrаct Аddress</div>
        <div>
          {formatAddress("0x27A95F8e0f465c8835B0E887f8A1531440067721")}
          <button
            onClick={() => {
              navigator.clipboard.writeText("0x27A95F8e0f465c8835B0E887f8A1531440067721");
              setCopyAddress(true);
            }}>
            {copyIcon()}
          </button>
          {copyAddress ? "Copied!" : null}
        </div>
      </TableRow>
      <TableRow>
        <div>Sale Contrаct</div>
        <div>
          {formatAddress("0x27A95F8e0f465c8835B0E887f8A1531440067721")}
          <button
            onClick={() => {
              navigator.clipboard.writeText("0x27A95F8e0f465c8835B0E887f8A1531440067721");
              setCopyContract(true);
            }}>
            {copyIcon()}
          </button>
          {copyContract ? "Copied!" : null}
        </div>
      </TableRow>
      <TableRow>
        <div>Token ID</div>
        <div> 127</div>
      </TableRow>
      <TableRow>
        <div>Metаdаtа</div>
        <div>Centrаlized</div>
      </TableRow>
      <TableRow>
        <div>Royalties for the Creator</div>
        <div>10%</div>
      </TableRow>
    </TableWrapper>
  );
};
